import React, { useState, useEffect } from "react";
import { Fab, Tooltip, Zoom, Box } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { getData } from "../../Webservice/Webservice";

const WhatsAppButton = () => {
  const [whatsappNumber, setWhatsappNumber] = useState("+91 98844 53499");

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const res = await getData("content/contact-address", null, null, false);
        if (res?.data?.content) {
          const c = res.data.content;
          if (c.whatsapp) {
            setWhatsappNumber(c.whatsapp);
          } else if (c.phone) {
            setWhatsappNumber(c.phone);
          }
        }
      } catch (err) {
        console.error("Failed to load WhatsApp enquiry contact:", err);
      }
    };
    fetchContactInfo();
  }, []);

  const cleanNumber = (whatsappNumber || "").replace(/[^0-9]/g, "");
  if (!cleanNumber) return null;

  const enquiryMessage = encodeURIComponent(
    "Hi Kanaa Decor, I would like to enquire about your event decoration services."
  );
  const whatsappUrl = `https://wa.me/${cleanNumber}?text=${enquiryMessage}`;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 24, md: 32 },
        right: { xs: 20, md: 32 },
        zIndex: 1400,
      }}
    >
      <Tooltip
        title={`Chat with us on WhatsApp (${whatsappNumber})`}
        placement="left"
        TransitionComponent={Zoom}
        arrow
      >
        <Fab
          component="a"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Enquire on WhatsApp"
          sx={{
            width: { xs: 54, md: 62 },
            height: { xs: 54, md: 62 },
            background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
            color: "#ffffff",
            boxShadow: "0 6px 20px rgba(37, 211, 102, 0.45)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              background: "linear-gradient(135deg, #1ebe5d 0%, #0d6e62 100%)",
              transform: "scale(1.08) translateY(-2px)",
              boxShadow: "0 10px 25px rgba(37, 211, 102, 0.6)",
            },
            "&:active": {
              transform: "scale(0.96)",
            },
            animation: "pulseShadow 2.5s infinite",
            "@keyframes pulseShadow": {
              "0%": {
                boxShadow: "0 0 0 0 rgba(37, 211, 102, 0.55)",
              },
              "70%": {
                boxShadow: "0 0 0 16px rgba(37, 211, 102, 0)",
              },
              "100%": {
                boxShadow: "0 0 0 0 rgba(37, 211, 102, 0)",
              },
            },
          }}
        >
          <WhatsAppIcon sx={{ fontSize: { xs: 30, md: 36 } }} />
        </Fab>
      </Tooltip>
    </Box>
  );
};

export default WhatsAppButton;
